/* lua.js generated code undefined */

let config = table(
    [1, 0, table(
        [1, "min", 1],
        [1, "max", 100],
        [1, "check", function (personalDiff, natureDiff) {
            he_log_info(string.format("pdiff:%s, ndiff:%s", personalDiff, natureDiff))
            if (personalDiff >= 6) { //可定期根据线上数据调整数值，或优化划分方式，一期采用的分类标准为难度的绝对值以及和中位难度差异
                return 0
            } else if (personalDiff >= 4) {
                return 1
            } else {
                return 3
            }
        }]
    )],
    [1, 1, table(
        [1, "min", 101],
        [1, "max", 200],
        [1, "check", function (personalDiff, natureDiff) {
            if (natureDiff >= 2) {
                if (personalDiff >= natureDiff + 5 || personalDiff >= 10) {
                    return 0
                } else if (personalDiff >= natureDiff + 3 || personalDiff >= 6) {
                    return 1
                } else {
                    return 3
                }
            } else if (natureDiff >= 1) {
                if (personalDiff >= 6) {
                    return 0
                } else if (personalDiff >= 4) {
                    return 1
                } else {
                    return 3
                }
            } else {
                return 3
            }
        }]
    )],
    [1, 2, table(
        [1, "min", 201],
        [1, "max", 400],
        [1, "check", function (personalDiff, natureDiff) {
            if (natureDiff >= 5) {
                if (personalDiff >= natureDiff + 10 || personalDiff >= 18) {
                    return 0
                } else if (personalDiff >= natureDiff + 6) {
                    return 1
                } else if (personalDiff >= natureDiff + 3) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 3) {
                if (personalDiff >= 10) {
                    return 0
                } else if (personalDiff >= 7) {
                    return 1
                } else {
                    return 3
                }
            } else if (natureDiff >= 1) {
                if (personalDiff >= 7) {
                    return 0
                } else if (personalDiff >= 5) {
                    return 1
                } else {
                    return 3
                }
            } else {
                return 3
            }
        }]
    )],
    [1, 3, table(
        [1, "min", 401],
        [1, "max", 800],
        [1, "check", function (personalDiff, natureDiff) {
            if (natureDiff >= 7) {
                if (personalDiff >= natureDiff + 12 || personalDiff >= 22) {
                    return 0
                } else if (personalDiff >= natureDiff + 8) {
                    return 1
                } else if (personalDiff >= natureDiff + 4) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 4) {
                if (personalDiff >= 12) {
                    return 0
                } else if (personalDiff >= 10) {
                    return 1
                } else if (personalDiff >= 8) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 1) {
                if (personalDiff >= 8) {
                    return 0
                } else if (personalDiff >= 6) {
                    return 1
                } else if (personalDiff >= 4) {
                    return 2
                } else {
                    return 3
                }
            } else {
                return 3
            }
        }]
    )],
    [1, 4, table(
        [1, "min", 801],
        [1, "max", function () {
            return UserManager.getInstance().getMaxLevelServer() - 15
        }],
        [1, "check", function (personalDiff, natureDiff) {
            if (natureDiff >= 11) {
                if (personalDiff >= natureDiff + 18 || personalDiff >= 35) {
                    return 0
                } else if (personalDiff >= natureDiff + 12 || personalDiff >= 25) {
                    return 1
                } else if (personalDiff >= natureDiff + 8) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 7) {
                if (personalDiff >= 20) {
                    return 0
                } else if (personalDiff >= 18) {
                    return 1
                } else if (personalDiff >= 16) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 4) {
                if (personalDiff >= 16) {
                    return 0
                } else if (personalDiff >= 14) {
                    return 1
                } else if (personalDiff >= 12) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 1) {
                if (personalDiff >= 9) {
                    return 0
                } else if (personalDiff >= 7) {
                    return 1
                } else if (personalDiff >= 5) {
                    return 2
                } else {
                    return 3
                }
            } else {
                return 3
            }
        }]
    )],
    [1, 5, table(
        [1, "min", function () {
            return UserManager.getInstance().getMaxLevelServer() - 14
        }],
        [1, "max", function () {
            // WARN: maybe multi result
            return UserManager.getInstance().getMaxLevelServer()
        }],
        [1, "check", function (personalDiff, natureDiff) {
            if (natureDiff >= 12) {
                if (personalDiff >= 30) {
                    return 0
                } else if (personalDiff >= 22) {
                    return 1
                } else if (personalDiff >= 18) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 7) {
                if (personalDiff >= 20) {
                    return 0
                } else if (personalDiff >= 16) {
                    return 1
                } else if (personalDiff >= 12) {
                    return 2
                } else {
                    return 3
                }
            } else if (natureDiff >= 4) {
                if (personalDiff >= 16) {
                    return 0
                } else {
                    return 3
                }
            } else if (natureDiff >= 1) {
                if (personalDiff >= 10) {
                    return 0
                } else {
                    return 3
                }
            } else {
                return 3
            }
        }]
    )]
)
module.exports = config
